import dynamic from 'next/dynamic'
import { ReactNode, Suspense } from 'react'
import HippoHeader from './components/hippo-header'
const Menu = dynamic(() => import('./menu'))

const Header = ({
    className,
    children,
    showMenu,
}: {
    className?: string
    showMenu?: boolean
    children?: ReactNode
}) => {
    return (
        <div className={`navbar bg-base-200 ${className}`}>
            <div className="flex-1">
                <a className="btn btn-ghost text-xl">
                    <HippoHeader />
                </a>
            </div>
            {showMenu && (
                <Suspense fallback={<div className="w-12 flex-none" />}>
                    <Menu />
                </Suspense>
            )}
            {children}
        </div>
    )
}

export default Header
